<template lang="pug">
div
    .media-info
      h3(style="grid-column: 1 / span 2") {{ item.name || "Details" }}
      div ID:
      div {{ item.id }}
      template(v-if="item.mime_type") 
        div MIME-Type:
        div {{ item.mime_type }}
      template
        div Size:
        div {{ item.width }} x {{ item.height }}
      template
        div Camera:
        div {{ item.camera_model }}
      template(v-if="item.date_taken") 
        div Erstellt am:
        div {{ formatDate(item.date_taken) }}
      template(v-if="item.size") 
        div Größe:
        div {{ formatSize(item.size) }}
      template(v-if="item.exif")
        template(v-for="t in exif", v-if="item.exif[t.value]") 
          div {{ t.name }}
          div {{ item.exif[t.value] }} {{ t.suffix }}
      h3(style="grid-column: 1 / span 2") Personen
      template(v-if="item.faces",v-for="f in item.faces")
          div {{f.index}}
          div {{f.name}}
    //-   template(v-for="(t, ix) in item.exif") 
          div {{ ix }}: 
          div {{ t }}
      div(style="grid-column: 1 / span 2") {{ JSON.stringify(item, null, 2) }}
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      exif: [
        { name: "Hersteller", value: "Make", suffix: "m" },
        { name: "Kamera", value: "Model", suffix: "m" },
        { name: "Height", value: "GPSAltitude", suffix: "m" },
        { name: "Bytes", value: "Megapixels", suffix: "MB" },
        { name: "Aperture", value: "ApertureValue" },
        { name: "Belichtung", value: "ExposureTime" },
        { name: "Brightness", value: "BrightnessValue" },
        { name: "Brennweite", value: "FocalLength" },
        { name: "ISO", value: "ISO" },
        { name: "Blitz", value: "Flash" },
        { name: "Winkel", value: "FOV" },
        { name: "Hyperfocal", value:"HyperfocalDistance"}
      ],
    };
  },
  methods: {
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleString();
    },
    formatSize(bytes) {
      const kb = bytes / 1024;
      return kb < 1024 ? `${kb.toFixed(1)} KB` : `${(kb / 1024).toFixed(1)} MB`;
    },
  },
};
</script>

<style lang="less" scoped>
.media-info {
  display: grid;
  grid-template-columns: 1fr 3fr;
  justify-items: left;
  align-content: flex-start;
  overflow: auto;
  z-index: 11;
  position: absolute;
  left: 4vw;
  right: 4vw;
  top: 10vw;
  bottom: 4vw;
  padding: 8vw;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(12px);
  color: black;
  font-size: 3.5vw;
  border: 1px solid gray;
  border-radius: 1vw;
  box-shadow: 1vw 1vw 1vw #000;
//   @media (min-aspect-ratio: 4/3) {
//     width: 25vw;
//     max-height: 90vh;
//     border-left: 1px solid rgba(255, 255, 255, 0.2);
//   }

//   @media (max-aspect-ratio: 4/3) {
//     width: 100%;
//     max-height: 90vh;
//     border-top: 1px solid rgba(255, 255, 255, 0.2);
//   }
}
</style>